export const ProfileStoryData = [
  {
    id: 1,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_02.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_03.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_04.jpg",
    ],
    title: "속초",
  },
  {
    id: 2,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_03.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_04.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_05.jpg",
    ],
    title: "일본",
  },
  {
    id: 3,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_04.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_05.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_06.jpg",
    ],
    title: "맛집",
  },
  {
    id: 4,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_05.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_06.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_02.jpg",
    ],
    title: "카페",
  },
  {
    id: 5,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_06.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_02.jpg",
      "https://dongsooo.github.io/imgs/dongstgram_img/06_profile_img_03.jpg",
    ],
    title: "카페2",
  },
];
